import { API } from "aws-amplify";
import { logger } from "./index";
import { Invite } from "../models/Invite";
import { REST_API } from "../constants";
import { CognitoAuth } from "./CognitoAuth";
import { isLead } from "../constants"

const path = "/invites";

export class Invites {
  // future use?  customer invites co-exec, attorney, or advisor?
  async createInvite(invite: Invite): Promise<string | null> {
    try {
      const data = await API.post(REST_API, path, {
        body: invite.toJSON(),
      });
      // logger.debug(data);
      if (data?.data?.id) {
        return data.data.id;
      } else {
        logger.error("no id returned");
      }
    } catch (error) {
      !isLead && CognitoAuth.handleError(error, "createInvite error");
    }
    return null;
  }
  // async redeemInvite(inviteId: string): Promise<boolean> {
  //   try {
  //     const data = await callPut(
  //       `${ADVISOR_PUBLIC_REST_URL}${path}/${inviteId}`,
  //       {},
  //       true,
  //       {
  //         baseURL: "",
  //       }
  //     );
  //     // logger.debug(data);
  //     if (data?.data) {
  //       return data.data === "success";
  //     } else {
  //       logger.error("invite redemption failed", false);
  //     }
  //   } catch (error) {
  //     logger.error(error as Error, false);
  //   }
  //   return false;
  // }
}
